import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../reusable-components/iconify';

TicketUserAction.propTypes = {
  item: PropTypes.object,
  idx: PropTypes.number,
};
export default function TicketUserAction({ item, idx }) {
  const userActionStyle = {
    fontSize: '13px',
    textAlign: 'center',
    ml: 2,
    mb: 1,
  };

  if (item.type === 'addUser' || item.type === 'removeUser') {
    return (
      <Box key={item.id} sx={{ ...userActionStyle, mt: idx === 0 ? 2.5 : 1 }}>
        <Iconify
          icon={item.type === 'addUser' ? 'icons8:add-user' : 'icons8:remove-user'}
          width="32"
          height="32"
          sx={{ mr: 0.5 }}
        />
        {item.message}
      </Box>
    );
  }
  return null;
}


